import React, { Component } from 'react';
import './App.css';
import { RedocStandalone } from 'redoc';


class App extends Component {
   render() {
    return (
      <div className="App">
        <div className="navbar">
          <p className="logo">XTS-API</p>
        </div>
        <div className="redocDiv">
          <RedocStandalone
            specUrl="./data.json"
            options={{
              nativeScrollbars: true,
              theme: { colors: { main: '#dd5522' } },
            }}
          />
        </div>
      </div>
    );
  }
}

export default App;
